import React, { Component } from 'react'
import CSV from 'comma-separated-values'
import { post } from './util'
import Modal from './components/Modal'
import Button from './components/Button'
import Panel from './components/Panel'

class ImportCSV extends Component {
  state = {
    loading: false,
    csv: '',
    tab: 'preview'
  }

  placeholder = ['name,passcode,quota', 'bob,e82hf1s,2', 'jeff,x92pzm9,5', 'david,,10', 'lucy,a91pzjr'].join('\r\n')

  parseCSV () {
    const csv = new CSV(this.state.csv, { cast: false, header: true })
    let parsed
    try {
      parsed = csv.parse()
    } catch (e) {
      return e
    }

    return parsed.map(o => {
      if (o.quota) {
        o.quota = Number(o.quota)
      } else {
        delete o.quota
      }
      if (!o.passcode) {
        delete o.passcode
      }
      return o
    })
  }

  handleSave = () => {
    const parsed = this.parseCSV()
    if (parsed instanceof Error || !parsed.length) {
      alert(parsed instanceof Error ? parsed.message : 'No valid data')
      return
    }
    this.setState({ loading: true })
    post('admin/users', { users: parsed })
      .then(() => {
        this.setState({ loading: false })
        this.props.onSave()
      })
      .catch(e => {
        alert('Failed to add: ' + e.message)
        this.setState({ loading: false })
      })
  }

  renderTable () {
    const parsed = this.parseCSV()
    if (parsed instanceof Error) {
      return <p className='text-sm text-rose-500'>{parsed.message}</p>
    }
    if (!parsed.length) {
      return <p className='text-sm text-slate-500'>No valid data</p>
    }
    return (
      <div className='overflow-hidden rounded-2xl border border-slate-200 mt-2'>
        <table className='w-full text-sm'>
          <thead className='bg-slate-50 text-slate-600'>
            <tr>
              <th className='text-left px-3 py-2'>Name</th>
              <th className='text-left px-3 py-2'>Passcode</th>
              <th className='text-left px-3 py-2'>Quota</th>
            </tr>
          </thead>
          <tbody>
            {parsed.map(o => (
              <tr key={o.name} className='border-t border-slate-100'>
                <td className='px-3 py-2'>{o.name}</td>
                <td className='px-3 py-2'>{o.passcode}</td>
                <td className='px-3 py-2 text-slate-500'>{o.quota || this.props.defaultQuota}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render () {
    return (
      <Modal
        open={Boolean(this.props.show)}
        onClose={this.props.onClose}
        title='Import Users via CSV'
        footer={[
          <Button key='cancel' variant='ghost' onClick={this.props.onClose}>Cancel</Button>,
          <Button key='add' onClick={this.handleSave} disabled={this.state.loading}>
            {this.state.loading ? 'Importing…' : 'Add'}
          </Button>
        ]}
      >
        <textarea
          rows='8'
          className='w-full rounded-2xl border border-slate-200 px-4 py-3 font-mono text-sm focus:border-ink focus:ring-1 focus:ring-ink'
          value={this.state.csv}
          onChange={e => this.setState({ csv: e.target.value })}
          placeholder={this.placeholder}
        />
        <div className='flex gap-3 mt-4 text-sm font-semibold'>
          <button
            className={`pb-1 border-b-2 ${this.state.tab === 'preview' ? 'border-ink text-ink' : 'border-transparent text-slate-400'}`}
            onClick={() => this.setState({ tab: 'preview' })}
          >
            Preview
          </button>
          <button
            className={`pb-1 border-b-2 ${this.state.tab === 'help' ? 'border-ink text-ink' : 'border-transparent text-slate-400'}`}
            onClick={() => this.setState({ tab: 'help' })}
          >
            Help
          </button>
        </div>
        <div className='mt-3 text-sm text-slate-600'>
          {this.state.tab === 'preview'
            ? this.renderTable()
            : (
              <Panel tight>
                Each row accepts <code>name</code>, <code>passcode</code> and <code>quota</code>. Only <code>name</code> is required and the CSV header must be present.
                <pre className='mt-2 text-xs text-slate-500'>{this.placeholder}</pre>
              </Panel>
              )}
        </div>
      </Modal>
    )
  }
}

export default ImportCSV
